export const animationKeys = [
    'in',
    'out',
    'duration',
    'animation',
    'isDisplayed',
    'animateInitialRender',
    'animationName',
    'animationDuration',
];
export const defaultAnimationDuration = 250;
